import {styled} from '@mui/material/styles'
import {
  Button,
  Checkbox,
  TableContainer,
  ListItem,
  ListItemText,
  MenuItem,
  Box,
  IconButton,
  TableRow,
  Typography,
  List
} from '@mui/material'
import TableCell, {tableCellClasses} from '@mui/material/TableCell'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Popover from '@mui/material/Popover'
import CircleIcon from '@mui/icons-material/Circle'

export const StyledTableCell = styled(TableCell)(({theme}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  whiteSpace: 'nowrap',
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}))

export const StyledCheckbox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.common.white,
  '&.Mui-checked': {
    color: theme.palette.common.white
  }
}))

export const StyledTableContainer = styled(TableContainer, {shouldForwardProp: (prop) => prop !== 'loading'})(
  ({loading}) => ({
    position: 'relative',
    overflowX: 'auto',
    display: loading ? 'flex' : 'grid',
    width: '100%'
  })
)

export const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)(() => ({
  cursor: 'pointer'
}))

export const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(({theme}) => ({
  cursor: 'pointer',
  color: theme.palette.common.blue1
}))

export const StyledSortingDiv = styled('div')(() => ({
  alignItem: 'center',
  display: 'flex'
}))

export const StyledSpan = styled('div')(({theme}) => ({
  padding: '5px',
  borderRadius: '44px',
  backgroundColor: theme.palette.common.green,
  margin: '3px 5px 3px 0px',
  fontSize: '11px',
  color: theme.palette.common.black,
  height: '100%',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  cursor: 'auto'
}))

export const StyledInterestDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'showLess'
})(({showLess}) => ({
  display: showLess ? 'flex' : 'inline-flex',
  justifyContent: 'flex-start',
  flexWrap: showLess ? 'wrap' : '',
  alignItems: 'center',
  border: 'none',
  padding: 0,
  margin: 0
}))

export const StyledTableContactReportCell = styled(TableCell)(({theme}) => ({
  paddingBottom: 0,
  paddingTop: 0,
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}))

export const StyledShowMoreButton = styled(Button)(({theme}) => ({
  fontSize: '11px',
  textTransform: 'none',
  marginLeft: '5px',
  whiteSpace: 'nowrap',
  color: theme.palette.common.grey4,
  ':hover': {
    backgroundColor: 'inherit'
  }
}))

export const StyledListItemText = styled(ListItemText)(() => ({
  '& .MuiListItemText-primary': {
    fontSize: '12px'
  }
}))

export const StyledMenuItem = styled(MenuItem)(() => ({
  '&.MuiMenuItem-dense': {
    padding: '0px 10px'
  }
}))

export const StyledLoaderBox = styled(Box)(({theme}) => ({
  display: '-webkit-box',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)'
}))

export const StyledCellDiv = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row'
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  border: `1px solid ${theme.palette.greyShade}`,
  borderRadius: '4px',
  textWrap: 'nowrap',
  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.grey}`,
    color: theme.palette.common.grey
  }
}))

export const StyledTableRow = styled(TableRow)(({theme}) => ({
  cursor: 'pointer',
  ':hover': {
    backgroundColor: theme.palette.common.black2
  }
}))

export const StyledTypography = styled(Typography, {shouldForwardProp: (prop) => prop !== 'showPointer'})(
  ({theme, showPointer}) => ({
    cursor: showPointer ? 'pointer' : 'auto',
    fontSize: theme.typography.heading.fontSize.xxs
  })
)

export const StyledFlaggedIcon = styled(AssistantPhotoIcon)(({theme}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: theme.palette.common.white,
  height: '15px',
  width: '15px'
}))

export const IconCircularDiv = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.common.orange2,
  borderRadius: '50%',
  width: '100%',
  height: '100%',
  position: 'absolute'
}))

export const FlagIconDivContainer = styled('div')(({theme}) => ({
  position: 'relative',
  width: '20px',
  height: '20px',
  marginBottom: '2px'
}))

export const StyledArrowDropdownIcon = styled(ArrowDropDownIcon)(({theme}) => ({
  cursor: 'pointer',
  verticalAlign: 'middle',
  marginLeft: '4px',
  fontSize: '20px',
  color: theme.palette.common.grey4
}))

export const StyledPopover = styled(Popover)(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px'
  }
}))

export const StyledBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(2),
  maxWidth: '400px'
}))

export const StyledListItem = styled(ListItem)(() => ({
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1
}))

export const StyledEducationListItemBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8
}))

export const StyledNoDataTypography = styled(StyledTypography)({
  fontStyle: 'italic',
  color: 'grey'
})

export const StyledList = styled(List)({
  padding: 0
})

export const StyledCircleIcon = styled(CircleIcon)({
  fontSize: 6
})
